import { render, staticRenderFns } from "./PortMappingDocument.vue?vue&type=template&id=423e5fb6&scoped=true&"
import script from "./PortMappingDocument.vue?vue&type=script&lang=js&"
export * from "./PortMappingDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423e5fb6",
  null
  
)

export default component.exports